module.exports = ".switch-team-modal .modal-footer {\n  text-align: center !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/switch-message/switch-message.component.scss
// module id = ./src/app/switch-message/switch-message.component.scss
// module chunks = main